import {Component, OnInit} from '@angular/core';
import {UserService} from '../user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NbToastrService, NbGlobalPhysicalPosition} from '@nebular/theme';

@Component({
  selector: 'ngx-user-activation',
  templateUrl: 'user-activation.component.html',
  styleUrls: ['user-activation.component.scss'],
})
export class UserActivationComponent implements OnInit {

  public users: any[] = []


  usersActived: any[] = [];
  usersDisactived: any[] = [];

  usersSelected: any[] = [];
  dropdownSettingsUser = {};
  public userLeaderSelected = [];


  constructor(private userService: UserService,
              private route: ActivatedRoute, private toastrService: NbToastrService, private router: Router) {
    this.usersSelected = [];
    this.dropdownSettingsUser = {
      idField: 'id',
      textField: 'firstName',
      singleSelection: true,
      selectAllText: 'Selecionar tudo',
      searchPlaceholderText: 'Localizar',
      unSelectAllText: 'Deselecionar Tudo',
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'Nenhum registro encontrado'
    };
  }

  ngOnInit() {
    this.getAllUsers();
  }

  getAllUsers() {
    this.usersActived = [];
    this.usersDisactived = [];
    this.userService.query().toPromise().then(result => {
      var res: any = result.body;
      for (let i = 0; i < res.length; i++) {
        const user = res[i];
        if (user.activated) {
          this.usersActived.push(user);
        } else {
          this.usersDisactived.push(user);
        }
      }
    })
  }

  save() {

    const listSave: any[] = [];

    for (let i = 0; i < this.usersActived.length; i++) {
      const user = this.usersActived[i];
      user.activated = true;
      listSave.push(user);
    }

    for (let i = 0; i < this.usersDisactived.length; i++) {
      const user = this.usersDisactived[i];
      user.activated = false;
      listSave.push(user);
    }
    this.userService.activate(listSave).toPromise().then(result => {
      this.toastrService.show('Usuário', 'Salvo com sucesso',
        {position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success'});
      this.goBack();
    })
  }

  goBack() {
    this.router.navigate(['pages/admin/user'])
      .then(() => {
        window.location.reload();
      });
  }

}
